import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";

// The results table scrolls inside itself with its header pinned, like the import grid, rather than
// running the page on down the screen.
const GRID_MAX_HEIGHT = "50vh";

// Every message on screen is the one the backend returned for that row. It knows whether an advisor
// was granted, was already accredited, did not pass, or was not found at all, and it owns the
// wording. Composing a message here would be a second version of the truth.
// The row's own flags name the outcome. A created advisor is called out separately from one who
// was already on Equipe, because that row put somebody new into the campaign.
function outcomeOf(row) {
     if (!row.isSuccess) {
          return "Not granted";
     }

     if (row.isCreated) {
          return row.isGranted ? "Created, accredited" : "Created";
     }

     if (row.isGranted) {
          return "Granted";
     }

     if (row.isAlreadyAccredited) {
          return "Already accredited";
     }

     return "No pass recorded";
}

export default function OptimumFrictionAccreditationResults(props) {
     const { result, rows, onDone } = props;

     const payload = result?.data || result || {};

     const results = payload.rows || [];
     const total = payload.total ?? results.length;
     const granted = payload.granted ?? 0;
     const created = payload.created ?? 0;
     const failed = payload.failed ?? 0;

     const data = results.map((row) => {
          const submitted =
               (rows || []).find(
                    (candidate) => candidate.rowNumber === row.rowNumber,
               ) || {};

          return {
               ...row,
               name:
                    row.fullName ||
                    `${submitted.firstName || ""} ${submitted.lastName || ""}`.trim(),
               email: row.email || submitted.email || "",
               dealerCode: row.dealerCode || submitted.dealerCode || "",
               outcome: outcomeOf(row),
               detail: row.reason || "",
          };
     });

     const rowRender = (element, rowProps) => {
          if (rowProps.dataItem.isSuccess) {
               return element;
          }

          return React.cloneElement(
               element,
               {
                    ...element.props,
                    style: { backgroundColor: "#fdecea" },
               },
               element.props.children,
          );
     };

     return (
          <Box sx={{ pt: 2 }}>
               <Typography variant="h6" sx={{ mb: 1 }}>
                    {granted} of {total} accredited
                    {created ? `, ${created} created and invited` : ""}
                    {failed ? `, ${failed} could not be used` : ""}
               </Typography>

               <Grid
                    data={data}
                    className="sba-area-data-grid"
                    rowRender={rowRender}
                    style={{ maxHeight: GRID_MAX_HEIGHT }}
               >
                    <GridColumn field="rowNumber" title="Row" width="90px" />
                    <GridColumn field="name" title="Advisor" width="200px" />
                    <GridColumn field="email" title="Email" width="260px" />
                    <GridColumn
                         field="dealerCode"
                         title="Dealer Code"
                         width="140px"
                    />
                    <GridColumn field="outcome" title="Outcome" width="140px" />
                    <GridColumn field="detail" title="Detail" width="420px" />
               </Grid>

               <Box sx={{ pt: 3 }}>
                    <Button type="button" themeColor="primary" onClick={onDone}>
                         Done
                    </Button>
               </Box>
          </Box>
     );
}
